.pill {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding-block: 3px;
  padding-inline: var(--space-2) var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--surface-elevated);
  color: var(--text);
  font-family: var(--font-figure);
  font-size: var(--text-xs);
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
}

.mark {
  inline-size: 10px;
  block-size: 10px;
  flex: none;
}

.neutral .mark {
  color: var(--text-muted);
}

.positive {
  border-color: color-mix(in srgb, var(--positive) 55%, transparent);
}

.positive .mark {
  color: var(--positive);
}

.warning {
  border-color: color-mix(in srgb, var(--warning) 55%, transparent);
}

.warning .mark {
  color: var(--warning);
}
